<div class="MainDiv">
	<div>
		<caass-manual-selector-extended-info [SelectedPerson]="SelectedPerson" [FacilityID]="FacilityID">
			[AudienceMode]="AudienceMode"
		</caass-manual-selector-extended-info>
	</div>

	<div>
		<!--Scan Time-->
		<div class="ItemBorder">
			<div class="Grid4Col">
				<label>Scan Time:</label>
				<label>{{ CurrentTime }}</label>

				<label class="MarginLeft">Date:</label>
				<label>{{ CurrentDate }}</label>
			</div>
		</div>

		<!--Type and Reason-->
		<div class="ItemBorder">
			<div class="Grid2Col">
				<label>Time Scan Type:</label>
				<label>{{ TimeScanTypeDesc }}</label>

				<label>Manual Mode Reason:</label>
				<select class="form-control" name="IDStatus" (ngModelChange)="onReasonChange($event)" [(ngModel)]="IDStatus" [disabled]="IsLoading() == true">
					<option value="" style="display: none"></option>
					<option *ngFor="let o of lstReasons" [ngValue]="o">
						{{ o.IDStatusDesc }}
					</option>
				</select>

				<label>Comments:</label>
				<textarea class="TextArea" [(ngModel)]="Comments" [disabled]="IsLoading() == true"> </textarea>
			</div>
		</div>

		<!--Fines-->
		<div class="ItemBorder">
			<div class="Grid2Col">
				<label *ngIf="CausesNewIDInd()">Replace Card:</label>
				<input
					*ngIf="CausesNewIDInd()"
					type="checkbox"
					class="CHK"
					[disabled]="IsLoading() == true"
					[(ngModel)]="PrintNewCard"
					(ngModelChange)="onPrintNewCardChange($event)"
				/>

				<label *ngIf="CausesNewIDInd() && IDCardFee > 0">Charge for Replacement Card:</label>
				<input
					*ngIf="CausesNewIDInd() && IDCardFee > 0"
					type="checkbox"
					class="CHK"
					[disabled]="IsLoading() == true"
					[(ngModel)]="ChargeIDCardFee"
					(ngModel)="onChargeIDCardFeeChange($event)"
				/>

				<label *ngIf="CausesNewIDInd() && IDCardFee > 0">Replacement Cost:</label>
				<label *ngIf="CausesNewIDInd() && IDCardFee > 0">{{ IDCardFeeDisplay }}</label>
				<!-- <input type="number" [disabled]="IsLoading() == true" [(ngModel)]="IDCardFee"> -->

				<label *ngIf="CausesNewIDInd()">Print Temporary Card:</label>
				<input
					*ngIf="CausesNewIDInd()"
					type="checkbox"
					class="CHK"
					[disabled]="IsLoading() == true"
					[(ngModel)]="PrintTempCard"
					(ngModelChange)="onPrintTempCardChange($event)"
				/>

				<label *ngIf="CausesNewIDInd() && TempIDFee > 0">Charge for Temporary Card:</label>
				<input
					*ngIf="CausesNewIDInd() && TempIDFee > 0"
					type="checkbox"
					class="CHK"
					[disabled]="IsLoading() == true"
					[(ngModel)]="ChargeTempID"
					(ngModelChange)="onChargeTempIDChange($event)"
				/>

				<label *ngIf="CausesNewIDInd() && TempIDFee > 0">Temporary Card Cost:</label>
				<!-- <input type="number" [disabled]="IsLoading() == true" [(ngModel)]="TempIDFee"> -->
				<label *ngIf="CausesNewIDInd() && TempIDFee > 0">{{ TempIDFeeDisplay }}</label>

				<label>Amount Paid:</label>
				<input class="form-control" type="number" [disabled]="IsLoading() == true" [(ngModel)]="AmountPaid" min="0" [max]="FineMax" />

				<label>Total Balance Due:</label>
				<label>{{ GetFineTotal() }}</label>
			</div>
		</div>

		<div class="ItemBorder">
			<div class="Grid2Col">
				<label for="override">Allow student to enter even if they have alerts</label>
				<input class="form-control" id="override" type="checkbox" class="CHK" [(ngModel)]="Override" [disabled]="IsLoading() == true" />
			</div>
		</div>

		<div class="Buttons">
			<button class="btn btn-primary" [disabled]="IsLoading() == true" (click)="onMarkTime()">Manual Scan</button>
			<button class="btn btn-warning" [disabled]="IsLoading() == true" (click)="onCancel()">Cancel</button>
		</div>

		<!--Error Message-->
		<div class="TopMargin DivCenter">
			<div name="errorMessage" *ngIf="ErrorMessage" class="alert alert-danger">
				{{ ErrorMessage }}
			</div>
		</div>
	</div>
</div>
